import { format } from 'date-fns';

import { parseAirDateToISO } from '@air/utilities';

export const WORKSPACE_AGENT_CREDITS_DEPLETED_HEADING = "You're out of credits";

export const formatWorkspaceAgentCreditsCycleRefreshDate = (nextCycleStartAt: string | undefined) => {
  if (!nextCycleStartAt) {
    return null;
  }

  return format(parseAirDateToISO(nextCycleStartAt), 'MMMM d');
};

export type GetWorkspaceAgentCreditsDepletedBodyParams = {
  includeContactAdmin: boolean;
  nextCycleStartAt?: string;
};

export const getWorkspaceAgentCreditsDepletedBody = ({
  includeContactAdmin,
  nextCycleStartAt,
}: GetWorkspaceAgentCreditsDepletedBodyParams) => {
  const formattedDate = formatWorkspaceAgentCreditsCycleRefreshDate(nextCycleStartAt);

  const pauseSegment = formattedDate
    ? `Agent tasks and Canvas edits are paused until credits refresh on ${formattedDate} — or you upgrade.`
    : 'Agent tasks and Canvas edits are paused until your credits refresh — or you upgrade.';

  let body = `${pauseSegment} You can view, search, and manage assets in the meantime.`;

  if (includeContactAdmin) {
    body += ' Contact your admin.';
  }

  return body;
};
